import React from "react";
import { Layout } from "components/Layout/Layout";
import { EnquiryProvider } from "./context";
import { EnquiryPage } from "./EnquiryPage";

export const EnquiryIndex = () => {
  return (
    <EnquiryProvider>
      <Layout>
        <EnquiryPage />
      </Layout>
    </EnquiryProvider>
  );
};
